import React, { useContext, useEffect, useState, useRef } from 'react'
import ChatBot from "../components/ChatBot";
import { projectContext, loadingContext, intentsContext, urlValue, unfolder } from '../lib'
import SideBar from "../components/SideBar";
import TitleBar from "../components/TitleBar";


export default function ChatbotTool(){
    const [selectedProject, setSelectedProject] = useContext(projectContext);

    return (
        <div>
            <section className="general-container d-flex flex-row" id="container">
                <SideBar active={'ChatBot'} />
                <div className="d-flex flex-column w-100">
                    <div className="row_primary">
                        <div className="con_title_bar">
                            <TitleBar />
                        </div>
                    </div>
                    <div>
                        <iframe src={process.env.REACT_APP_IVA_FACTORY_CHATBOT_URL + `?project=${selectedProject.name}&template=nesting_studio`}
                            permissions="geolocation notifications midi" height="600" style={{width: '100%'}} frameBorder="0"/>
                    </div>
                </div>
            </section>
        </div>
    );
}